__webpack_require__.p = "/viptour2023/";